const cmpDebug = {

  init: function (element) {
    const bs4Overlay = element
    const bs4Toggle = document.createElement('div')
    const colCount = 12
    const height = document.documentElement.scrollHeight

    // Setup overlay
    bs4Overlay.id = 'bs4_overlay'

    let colHtml = ''
    for (let i = colCount - 1; i >= 0; i--) {
      colHtml += '<div class="col-sm-1"><i style="height:' + height + 'px"></i></div>'
    }
    bs4Overlay.innerHTML = '<div class="container"><div class="row">' + colHtml + '</div></div>'

    // Setup toggle button
    bs4Toggle.id = 'bs4_toggle'
    bs4Toggle.innerHTML = '<span class="toggle">Toggle Grid</span><span class="close">(Hide)</span><span class="edit-mode">(Editmode)</span>'
    document.body.appendChild(bs4Toggle)

    const toggleBtn = bs4Toggle.querySelector('.toggle')
    const closeBtn = bs4Toggle.querySelector('.close')
    const editModeBtn = bs4Toggle.querySelector('.edit-mode')

    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault()
      bs4Overlay.classList.toggle('active')
    })

    closeBtn.addEventListener('click', (e) => {
      e.preventDefault()
      bs4Overlay.classList.remove('active')
      bs4Toggle.classList.add('hidden')
    })

    editModeBtn.addEventListener('click', (e) => {
      e.preventDefault()
      document.body.classList.toggle('OnPageEditingMode')
    })
  }
}

export default cmpDebug
